import { useDispatch, useSelector } from "react-redux";
import { getDitaContent, selectDitaContent } from "../Content/ContentSlice";
import style from "./FAQContent.module.scss"
import classNames from "classnames";
import FAQSection from "./FAQSection";
import Loader from "../Loader/Loader";
import useAppModernisation from "../../hooks/useAppModernisation";

const FAQContent = ({ faqContent }) => {
  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();
  const { isAppMode } = useAppModernisation();
  let title = "";
  let faqQuestions;
  
  if (faqContent) {
    const chapter = faqContent.getElementsByTagName("chapter")[0];  
    if (chapter && chapter.attributes && chapter.attributes.href) {
      title = getTitle(chapter.attributes.href.value, content, dispatch, title);
      const childTopicRefs = chapter.children;
      faqQuestions = Array.from(childTopicRefs).map((topic) => createFaqSection(topic, content, dispatch, title));
    }
  }

  return (
    <div className={style.faqPage}>
      {title ? (
        <div>
          {!isAppMode && (
            <div className={classNames("size-36 regular", style.title)}>
              {title}
            </div>
          )}
          <div className={style.contentSection}>{faqQuestions}</div>
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default FAQContent;

function getTitle(href, content, dispatch, title) {
  const filePath = "Changes/FAQs/" + href;
  const titleContents = getDitaContent(filePath, content, dispatch);
  
  if (titleContents) {
    let titleElement = titleContents.getElementsByTagName("title")[0];
    if (!titleElement) {
      titleElement = titleContents.getElementsByTagName("ditatitle")[0];
    }
    
    if (titleElement && titleElement.textContent) {
      return titleElement.textContent;
    }
  }
  return title;
}

function createFaqSection(topic, content, dispatch, title) {
  if (topic.children.length > 0) {
    const sectionTitle = getTitle(topic.attributes.href.value, content, dispatch, title);
    const childrenSections = Array.from(topic.children).map((topic) => createFaqSection(topic, content, dispatch, title));
    return (
      <div className={style.questionSection} key={topic.attributes.href.value}>
        <div className={classNames("size-22 semibold", style.sectionHeading)}>{sectionTitle}</div>
        <div>{childrenSections}</div>
      </div>
    )
  } else {
    return (
      <FAQSection topic={topic} key={topic.attributes.href.value}></FAQSection>
    )
  }
}
